import API from '@/views/Fdc/Apis/'
// import { mapGetters } from 'vuex'
import Dayjs from 'dayjs'
import TrendAnalysisModal from '@/views/Fdc/Analysis/Components/TrendAnalysisModal'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'
import Plotly from 'plotly.js-dist'

/**
 * TODO: 수정해야 할 항목 정리
 */
// FIXME: 1.

/**
 * Analysis > Summary Data Analysis
 * Summary Data Analysis
 */
export default {
  name: 'FdcSummaryDataAnalysis',
  computed: {
    // ...mapGetters([
    //   'user',
    //   'authed'
    // ])
  },
  components: {
    'trend-analysis-modal': TrendAnalysisModal // Trend Analysis Chart component
  },
  watch: {
    /**
     * fromDate 변화 감지
     */
    fromDate () {
      this.toMinDate = this.fromDate
    },
    /**
     * toDate 변화 감지
     */
    toData () {
      this.fromMaxDate = this.toDate
    }
  },
  beforeMount () {
    this.initColumns()
  },
  mounted () {
    // window.addEventListener('beforeunload', this.onClose)
  },
  methods: {
    /**
     * Columns initialize
     */
    initColumns () {
      this.paramListColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), field: 'aliasName', flex: 1, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), field: 'paramName', flex: 1, hide: true }
      ]
      this.recipeStepListColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', flex: 1, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP'), field: 'stepId', flex: 1 }
      ]
      this.smryTypeListColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.TYPE'), field: 'smryType', flex: 1, checkboxSelection: true, headerCheckboxSelection: true }
      ]
    },
    // onClose (event) {
    //   console.log('beforeunload')
    //   event.preventDefault()
    //   event.returnValue = ''
    // },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    async eqpTreeSelected (node) {
      this.selectedTreeNode = node

      // if (node.level !== 5) {
      //   return false
      // }

      // if (node.detail.moduleId === '') {
      //   return false
      //   // this.parseArr(node)
      // } else {
      //   this.fabList = node.detail.fab
      //   this.eqpList = node.detail.eqpId
      //   this.moduleList = node.detail.moduleId
      // }
    },
    /**
     * Summary Data Analysis 조회
     */
    async getSummaryData () {
      if (this.selectedTreeNode === null || this.selectedTreeNode.detail.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', [this.$t('fdc.COMMON.LABEL.MODULE')]))
        return false
      }

      let node = this.selectedTreeNode
      if (node.level !== 5) {
        return false
      }

      if (node.detail.moduleId === '') {
        return false
        // this.parseArr(node)
      } else {
        this.fabList = node.detail.fab
        this.eqpList = node.detail.eqpId
        this.moduleList = node.detail.moduleId
      }

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      let payload = {
        fab: this.fabList,
        eqpId: this.eqpList,
        moduleId: this.moduleList,
        useYn: 'Y',
        recipeId: 'ALL'
      }

      let paramList = await API.BaseInfo.getEqpParams(payload)
      let summaryParamList = await API.Collection.getSummaryPlanParams(payload)
      for (var summaryParam of summaryParamList) {
        let filterParamList = paramList.filter(param => param.paramName === summaryParam.paramName)
        if (filterParamList.length > 0) {
          summaryParam.aliasName = filterParamList[0].aliasName
        } else {
          // alias name이 없을 경우에는 임시로 paramName으로 처리
          summaryParam.aliasName = featureImportance.paramName
        }
      }
      this.paramListRowData = summaryParamList

      let stepList = await API.Collection.getSummaryPlanRecipes(payload)
      this.recipeStepListRowData = stepList

      let smryTypeList = await API.Collection.getSummaryPlanTypes(payload)
      this.smryTypeListRowData = smryTypeList

      let paramsParamList = []
      paramsParamList.push(summaryParamList[0].paramName)
      let paramsStepList = []
      paramsStepList.push(stepList[0].stepId)
      let paramsSummaryTypeList = []
      paramsSummaryTypeList.push('MEAN')

      let params = {
        reqSummaryPK: [{
          fabId: this.fabList,
          eqpId: this.eqpList,
          moduleId: this.moduleList
        }],
        paramList: paramsParamList,
        stepList: paramsStepList,
        summaryTypeList: paramsSummaryTypeList,
        lotStepYn: this.lotStepYn,
        fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + '000000000',
        toDate: Dayjs(this.toDate).format('YYYYMMDD') + '235959999',
        searchKind: 'SummaryDataAnalysis'
      }

      // console.log(params)
      // this.analysisChart.series.clear()
      // this.isLoading = true
      let smryData = await API.Analysis.getSummaryDatas(params)
      if (this.isEmpty(smryData)) {
        // this.tempSeriesData = [...smryData.datas]
        // this.tempParamName = [...smryData.paramNames]
        this.tempSeriesData = []
        this.tempParamName = []
        this.seriesData = []
        // this.seriesData = [...smryData.datas]
        return
      } else {
        // this.tempSeriesData = [...smryData.datas]
        // this.tempParamName = [...smryData.paramNames]
        // this.seriesData = [...smryData.datas]
      }
      // debugger
      // console.log(this.seriesData);
      this.setGridOneCheck(this.$refs.paramGrid, 'param', '')
      this.setGridOneCheck(this.$refs.recipeStepGrid, 'recipe', '')
      this.setGridOneCheck(this.$refs.smryTypeGrid, 'type', 'MEAN')
      this.selectSeries()
      this.drawChart(smryData)
      // this.getParamName();
      // this.getDataSeries();

      // this.yMin = Math.floor(yMin - ((yMax - yMin) * 0.2))
      // this.yMax = Math.floor(yMax + ((yMax - yMin) * 0.2))

      // setTimeout(() => {
      //   this.setGridOneCheck(this.paramListGrid, 'param', '')
      //   this.setGridOneCheck(this.recipeStepListGrid, 'recipe', '')
      //   this.setGridOneCheck(this.smryTypeListGrid, 'type', 'MEAN')
      //   // this.selectSeries()
      //   this.getDataSeries();
      // }, 10)

      // this.setGridAllCheck(this.paramListGrid, 'param')
      // this.setGridAllCheck(this.recipeStepListGrid, 'recipe')
      // this.setGridAllCheck(this.smryTypeListGrid, 'type')
    },
    /**
     * Draw Chart
     * @param {*} traces plotly chart data
     */
    async drawChart (traces) {
      let payload = {
        fab: this.fabList,
        eqpId: this.eqpList,
        moduleId: this.moduleList,
        useYn: 'Y',
        recipeId: 'ALL'
      }
      let paramList = await API.BaseInfo.getEqpParams(payload)
      let mapper = new Map()
      paramList.forEach(row => mapper.set(row.paramName, row.aliasName))

      // private final String mode = "markers";
      // private final String type = "scattergl";

      let paramsParamList = []
      this.$refs.paramGrid.gridApi.getSelectedRows().forEach(data => paramsParamList.push(data.paramName))
      let paramsStepList = []
      this.$refs.recipeStepGrid.gridApi.getSelectedRows().forEach(data => paramsStepList.push(data.stepId))

      let joinParamStepList = []
      for (var paramName of paramsParamList) {
        for (var stepId of paramsStepList) {
          joinParamStepList.push(paramName + '.' + stepId)
        }
      }
      let paramsSummaryTypeList = []
      this.$refs.smryTypeGrid.gridApi.getSelectedRows().forEach(data => paramsSummaryTypeList.push(data.smryType))

      traces.forEach(trace => {
        let temp = trace.name.split('.')
        trace.mode = 'markers'
        trace.type = 'scattergl'
        trace.name = trace.name.replace(temp[0], mapper.get(temp[0]))
        trace.x = trace.x.map(e => Dayjs(e).toDate())
        trace.hovertemplate = '<b>EndDt:</b> %{x}<br><b>Value:</b> %{y:.4f}'
        let color = this.getTraceColor(joinParamStepList.indexOf(temp[0] + '.' + temp[1]))
        let marker = this.getMakerSymbol(paramsSummaryTypeList.indexOf(temp[2]))
        trace.marker = {
          color: color,
          symbol: marker
        }
      })

      const layout = {
        showlegend: true,
        legend: {
          orientation: 'h',
          y: 1.2
        },
        hovermode: 'closest',
        xaxis: {
          tickformat: '%m/%d %H:%M:%S'
        }
      }
      const config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
      }
      BriqueChart.newPlot('analysisChart', traces, layout, config).then(() => {
        let chart = document.querySelector('#analysisChart')
        chart.on('plotly_click', event => { this.showTrendAnalysisModal(event.points[0]) })
      })
    },
    /**
     * Trend Analysis Modal show method
     * @param {*} point click된 series point
     */
    async showTrendAnalysisModal (point) {
      let lotId = point.data.lot[point.pointIndex]
      let aliasName = point.data.name.split('.')[0]
      let payload = {
        fab: this.fabList,
        eqpId: this.eqpList,
        moduleId: this.moduleList,
        useYn: 'Y',
        recipeId: 'ALL'
      }
      let paramName = (await API.BaseInfo.getEqpParams(payload)).find(element => element.aliasName === aliasName).paramName

      this.trendAnalysisModal.visible = true
      this.trendAnalysisObj = {
        fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + '000000000',
        toDate: Dayjs(this.toDate).format('YYYYMMDD') + '235959999',
        reqParam: [
          {
            fabId: this.fabList,
            eqpId: this.eqpList,
            moduleId: this.moduleList
          }
        ],
        lotId: [lotId],
        paramName: [paramName],
        reqParamName: [
          {
            fab: this.fabList,
            eqpId: this.eqpList,
            moduleId: this.moduleList,
            paramName: paramName
          }
        ]
      }
    },
    /**
     * Summary Data Analysis 조회 (검색 후 재조회)
     * Analysis button으로 조회할 때 동작합니다.
     */
    async getSummaryDataAfterSearch () {
      if (this.selectedTreeNode === null || this.selectedTreeNode.detail.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', [this.$t('fdc.COMMON.LABEL.MODULE')]))
        return false
      }

      let paramsParamList = []
      this.$refs.paramGrid.gridApi.getSelectedRows().forEach(data => paramsParamList.push(data.paramName))
      let paramsStepList = []
      this.$refs.recipeStepGrid.gridApi.getSelectedRows().forEach(data => paramsStepList.push(data.stepId))
      let paramsSummaryTypeList = []
      this.$refs.smryTypeGrid.gridApi.getSelectedRows().forEach(data => paramsSummaryTypeList.push(data.smryType))

      let params = {
        reqSummaryPK: [{
          fabId: this.fabList,
          eqpId: this.eqpList,
          moduleId: this.moduleList
        }],
        paramList: paramsParamList,
        stepList: paramsStepList,
        summaryTypeList: paramsSummaryTypeList,
        lotStepYn: this.lotStepYn,
        fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + '000000000',
        toDate: Dayjs(this.toDate).format('YYYYMMDD') + '235959999',
        searchKind: 'SummaryDataAnalysis'
      }

      // console.log(params)
      // this.analysisChart.series.clear()
      // this.isLoading = true
      let smryData = await API.Analysis.getSummaryDatas(params)
      if (this.isEmpty(smryData)) {
        this.tempSeriesData = []
        this.tempParamName = []
        this.seriesData = []
        // this.seriesData = [...smryData.datas]
        return
      } else {
        // this.tempSeriesData = [...smryData.datas]
        // this.tempParamName = [...smryData.paramNames]
        // this.seriesData = [...smryData.datas]
      }

      this.selectSeries()
      this.drawChart(smryData)
    },
    /**
     * Chart series 생성
     * @param {*} checkedParamName check된 parameter
     * @param {*} checkedStepId  check된 Recipe/Step
     * @param {*} checkedSumry check된 Summary Type
     * Grid에 check된 data로 chart series 배열을 생성합니다.
     */
    getParamName (checkedParamName, checkedStepId, checkedSumry) {
      this.paramNames = []
      let tempArr = []

      for (let i = 0; i < checkedParamName.length; i++) {
        for (let j = 0; j < checkedStepId.length; j++) {
          for (let k = 0; k < checkedSumry.length; k++) {
            tempArr.push(checkedParamName[i] + '.' + checkedStepId[j] + '.' + checkedSumry[k])
          }
        }
      }

      this.paramNames = this.tempParamName.filter((paramName) => {
        for (let i = 0; i < tempArr.length; i++) {
          if (paramName === tempArr[i]) return paramName
        }
      })
      // this.analysisChart.endUpdate()
    },
    /**
     * Chart data 재구성
     * @param {*} checkedParamName check된 parameter
     * @param {*} checkedStepId  check된 Recipe/Step
     * @param {*} checkedSumry check된 Summary Type
     * Grid에 check된 data로 chart data 배열을 재구성합니다.
     */
    getDataSeries (checkedParamName, checkedStepId, checkedSumry) {
      this.seriesData = this.tempSeriesData.filter((item) => {
        let tempKeyArr = Object.keys(item)
        let tempKey = tempKeyArr.filter(key => key !== 'endDt')
        let keyArr = tempKey[0].split('.')
        if (checkedParamName.includes(keyArr[0]) &&
          checkedStepId.includes(keyArr[1]) &&
          checkedSumry.includes(keyArr[2])
        ) {
          return item
        }
      })
      // this.analysisChart.endUpdate()
    },
    /**
     * Chart Series 및 Chart Data 생성
     */
    selectSeries () {
      const checkedParamName = this.$refs.paramGrid.gridApi.getSelectedRows().map(c => c.paramName)
      const checkedStepId = this.$refs.recipeStepGrid.gridApi.getSelectedRows().map(c => c.stepId)
      const checkedSumry = this.$refs.smryTypeGrid.gridApi.getSelectedRows().map(c => c.smryType)

      this.getParamName(checkedParamName, checkedStepId, checkedSumry)
      this.getDataSeries(checkedParamName, checkedStepId, checkedSumry)
      // this.analysisChart.series.clear()
      // this.analysisChart.beginUpdate()

      // for (let i = 0; i < this.paramNames.length; i++) {
      //   let paramStepType = this.paramNames[i]
      //   let series = new wjcChart.Series()

      //   series.symbolSize = 3
      //   series.symbolMarker = 0
      //   series.chartType = 'Scatter'
      //   // series.dateFormat = 'HH:mm:ss'
      //   series.binding = paramStepType
      //   series.name = paramStepType
      //   this.analysisChart.series.push(series)
      // }
      let yMin = null
      let yMax = null

      this.seriesData.forEach((item) => {
        let tempKeyArr = Object.keys(item)
        let tempKey = tempKeyArr.filter(key => key !== 'endDt')
        let data = item[tempKey[0]]
        if (yMin === null) yMin = data
        if (yMax === null) yMax = data
        if (yMin > data) yMin = data
        if (yMax < data) yMax = data
      })

      if (yMax === yMin) {
        this.yMin = yMin - 0.2
        this.yMax = yMax + 0.2
      } else {
        this.yMin = yMin - ((yMax - yMin) * 0.2)
        this.yMax = yMax + ((yMax - yMin) * 0.2)
      }
      // this.analysisChart.endUpdate()
      // this.analysisChart.beginUpdate()
      // this.analysisChart.series.forEach((item) => {
      //   item.visibility = 3
      //   if (checkedParamName.includes(item.name.split('.')[0]) &&
      //   checkedStepId.includes(item.name.split('.')[1]) &&
      //   checkedSumry.includes(item.name.split('.')[2])
      //   ) {
      //     item.visibility = 0
      //   }
      // })
      // this.analysisChart.endUpdate()
    },
    // setGridAllCheck (gridType, colStr) {
    //   let elRows = gridType.hostElement.lastElementChild.firstElementChild.firstElementChild
    //   for (var i = 0; i < elRows.children.length; i++) {
    //     if (i === 0) {
    //       continue
    //     }
    //     let elParamName = ''
    //     let elStepName = ''
    //     if (colStr === 'param') {
    //       elParamName = elRows.children[i].children[1].innerText
    //     } else if (colStr === 'type') {
    //       elParamName = elRows.children[i].children[1].innerText
    //     } else {
    //       elParamName = elRows.children[i].children[1].innerText
    //       elStepName = elRows.children[i].children[2].innerText
    //     }
    //     gridType.rows.forEach((item) => {
    //       let paramName = ''
    //       let stepName = ''
    //       if (colStr === 'param') {
    //         paramName = item.dataItem.paramName
    //       } else if (colStr === 'type') {
    //         paramName = item.dataItem.smryType
    //       } else {
    //         paramName = item.dataItem.recipeId
    //         stepName = item.dataItem.stepId
    //       }
    //       if (elParamName === paramName && elStepName === stepName) {
    //         item.dataItem._status.checked = true
    //       }
    //     })
    //     elRows.children[i].setAttribute('aria-selected', true)
    //     elRows.children[i].firstElementChild.firstElementChild.checked = true
    //   }
    // },
    /**
     * Grid data에서 1가지만 선택 (BRIQUE Grid version)
     * @param {*} grid grid
     * @param {String} colStr column string
     * @param {String} smryType option
     */
    setGridOneCheck (grid, colStr, smryType) {
      if (grid.getAllRows().length > 0) {
        const id = grid.$attrs.id
        if (id !== 'smryTypeGrid') {
          let check = false
          grid.gridApi.forEachNode(node => {
            if (!check) {
              node.setSelected(true)
              check = true
            }
          })
        } else {
          let check = false
          grid.gridApi.forEachNode(node => {
            if (!check && node.data.smryType === smryType) {
              node.setSelected(true)
              check = true
            }
          })
        }
        // let rows = gridType.rows
        // gridType.deferUpdate(() => {
        //   if (colStr === 'type') {
        //     rows.some(row => {
        //       let rowItem = row.dataItem
        //       if (rowItem.smryType === smryType) {
        //         rowItem._status.checked = true
        //         return true
        //       }
        //     })
        //   } else {
        //     let rowStatus = rows[0].dataItem._status
        //     rowStatus.checked = true
        //   }
        // })
      }
    },
    /**
     * Trend Analysis Modal 닫기
     */
    resetTrendAnalysisModal () {
      this.trendAnalysisModal.visible = false
    },
    /**
     * null 값 check
     */
    isEmpty (value) {
      if (value === '' || value == null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
        return true
      } else {
        return false
      }
    },
    /**
     * ParamName+StepId 별 series color 다르게 설정
     * @param {*} index paramName + stepId 순서
     * @returns marker color
     */
    getTraceColor (index) {
      const d3colors = Plotly.d3.scale.category10().range()
      var color = d3colors[index]
      return color
    },
    /**
     * Summary Type 별 symbol marker 변경
     * @param {*} index summary type 순서
     * @returns marker symbol type
     */
    getMakerSymbol (index) {
      let symbol = this.symbolMakerList[index]
      return this.isEmpty(symbol) ? 'circle' : symbol
    }
  },
  data () {
    return {
      fromDate: Dayjs().subtract(1, 'days').toDate(), // From Date (condition)
      fromMinDate: null, // From Date Min value
      fromMaxDate: new Date(), // From Date Max value
      toDate: new Date(), // To Date (condition)
      toMinDate: Dayjs().subtract(2, 'days').toDate(), // To Date Min value
      toMaxDate: new Date(), // To Date Max value
      lotStepYn: 'N', // Step or Lot-Step (condition)
      fabList: '', // Fab 목록 (condition)
      eqpList: '', // EQP ID 목록 (condition)
      moduleList: '', // Module ID 목록 (condition)
      selectedTreeNode: null, // 선택된 EQP Tree node
      paramNames: [], // Chart Series 배열
      tempParamName: [], // Chart Series 배열
      seriesData: [], // Chart Data
      tempSeriesData: [], // Chart Data
      // isStart: true,
      yMin: 0, // Chart y축 Min value
      yMax: 100, // Chart y축 Max value
      showMarker: false, // TODO :: 사용 용도 확인 필요함
      analysisChart: [], // Chart 객체
      paramListRowData: [], // Parameter List grid row data
      paramListGrid: [], // Parameter List grid 객체
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      paramListColumns: [], // Parameter List grid column 배열
      // paramListColumns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), binding: 'aliasName', width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), binding: 'paramName', width: '1*', readOnly: true, allowMerging: true, visible: false }
      // ], // Parameter List grid column 배열
      recipeStepListRowData: [], // Recipe List grid row data
      recipeStepListGrid: [], // Recipe List grid 객체
      recipeStepListColumns: [], // Recipe List grid column 배열
      // recipeStepListColumns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipeId', width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.STEP'), binding: 'stepId', width: '1*', readOnly: true }
      // ], // Recipe List grid column 배열
      smryTypeListRowData: [], // Summary Type List grid row data
      smryTypeListGrid: [], // Summary Type List grid 객체
      smryTypeListColumns: [], // Summary Type List column 배열
      // smryTypeListColumns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.TYPE'), binding: 'smryType', width: '1*', readOnly: true }
      // ], // Summary Type List column 배열
      // isLoading: false,
      // isFullPage: false,
      trendAnalysisModal: {
        visible: false
      }, // Trend Analysis Modal 표시 여부
      trendAnalysisObj: null, // Trend Analysis Modal 전달 Object
      symbolMakerList: ['circle', 'square', 'diamond', 'pentagon', 'hexagon', 'star', 'hexagram', 'star-diamond'] // plotly symbol marker 종류 list
    }
  }
}
